function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 45,
  r: 43.31,
  fill: "#bbb"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M64.83,58.36C57.36,66.83,41,80,23.86,58.22c-1.57-2-.42-5.36,1.82-5.36H63.13C65.45,52.86,66.54,56.41,64.83,58.36Z",
  fill: "#909090"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 59.9,
  cy: 35.01,
  r: 6.31,
  fill: "#909090"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 28.41,
  cy: 35.02,
  r: 6.31,
  fill: "#909090"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M73.24,12.17a43.3,43.3,0,0,1-62.73,59A43.31,43.31,0,0,0,88.31,45h0A43.2,43.2,0,0,0,73.24,12.17Z",
  fill: "#b6b6b6"
});

function SvgFace5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace5);
export default __webpack_public_path__ + "static/media/face_5.d36db297.svg";
export { ForwardRef as ReactComponent };